import scenes from '../scenes'
import * as overlayStyle from 'constants/overlayStyles'
import * as sidebarSceneType from 'constants/sidebarSceneType'
import * as customFieldTypes from 'constants/customFieldTypes'
import * as stylePresetType from 'constants/stylePresetType'

const customFields = [
  {
    id: 'preload',
    location: { scene: scenes[1] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene1', 'logo'],
      isSmall: true,
    },
    fields: [
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene1', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_splash__logo',
        customStyle: '.fi_splash__logo {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_splash__logo`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_splash__logo`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_splash__logo`,
            presetType: stylePresetType.AROUND
          },
          { className: 'fi_splash__logo', presetType: stylePresetType.HIDDEN },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene1', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_splash__title',
        customStyle: '.fi_splash__title {\n}',
        stylePresets: [
          { title: 'Move title:', className: 'fi_splash__title', presetType: stylePresetType.POSITION },
          {
            title: 'Text color:',
            className: 'fi_splash__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `fi_splash__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_splash__title--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_splash__title', presetType: stylePresetType.HIDDEN },
        ]
      }
    ]
  },
  {
    id: 'intro',
    location: { scene: scenes[2] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene2', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene2', 'bg']],
        isCurtain: true,
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_curtains__bg',
        customStyle: '.fi_curtains__bg {\n}'
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene2', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-2',
        customStyle: '.fi_logo-2 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-2`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-2`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-2`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-2`,
              `fi_logo-3`,
              `fi_logo-4`,
              `fi_logo-5`,
              `fi_logo-6`,
              `fi_logo-7`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene2', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_curtains__title',
        customStyle: '.fi_curtains__title {\n}',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_curtains__title',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: `fi_curtains__title`, presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_curtains__title--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_curtains__title', presetType: stylePresetType.HIDDEN },
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene2', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_curtains__text',
        customStyle: '.fi_curtains__text {\n}',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_curtains__text',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_curtains__text', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_curtains__text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_curtains__text', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene3',
    location: { scene: scenes[3] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene3', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene3', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_3',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene3', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-3',
        customStyle: '.fi_logo-3 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-3`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-3`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-3`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-4`,
              `fi_logo-5`,
              `fi_logo-6`,
              `fi_logo-7`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene3', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_3', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_3--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene3', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_3', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_3--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_3', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene3', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_3',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_3',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_3', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_3`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_3', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene4',
    location: { scene: scenes[4] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene4', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene4', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_4',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene4', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-4',
        customStyle: '.fi_logo-4 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-4`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-4`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-4`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-5`,
              `fi_logo-6`,
              `fi_logo-7`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene4', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_4', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_4--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_4', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene4', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_4', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_4--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_4', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene4', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_4',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_4',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_4', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_4`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_4', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene5',
    location: { scene: scenes[5] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene5', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene5', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_5',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene5', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-5',
        customStyle: '.fi_logo-5 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-5`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-5`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-5`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-6`,
              `fi_logo-7`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene5', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_5',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_5',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_5', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_5--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_5', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene5', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_5',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_5',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_5', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_5--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_5', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene5', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_5',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_5',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_5', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_5`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_5', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene6',
    location: { scene: scenes[6] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene6', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene6', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_6',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene6', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-6',
        customStyle: '.fi_logo-6 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-6`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-6`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-6`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-6`,
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-7`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene6', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_6',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_6',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_6', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_6--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_6', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene6', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_6',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_6',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_6', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_6--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_6', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene6', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_6',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_6',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_6', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_6`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_6', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene7',
    location: { scene: scenes[7] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene7', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene7', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_7',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene7', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-7',
        customStyle: '.fi_logo-7 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-7`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-7`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-7`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-7`,
              `fi_logo-6`,
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-8`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene7', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_7',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_7',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_7', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_7--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_7', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene7', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_7',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_7',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_7', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_7--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_7', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene7', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_7',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_7',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_7', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_7`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_7', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene8',
    location: { scene: scenes[8] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene8', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene8', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_8',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene8', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-8',
        customStyle: '.fi_logo-8 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-8`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-8`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-8`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-8`,
              `fi_logo-7`,
              `fi_logo-6`,
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-9`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene8', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_8',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_8',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_8', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_8--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_8', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene8', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_8',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_8',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_8', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_8--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_8', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene8', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_8',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_8',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_8', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_8`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_8', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'scene9',
    location: { scene: scenes[9] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene9', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene9', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_slide__bg_9',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene9', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-9',
        customStyle: '.fi_logo-9 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-9`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-9`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-9`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-9`,
              `fi_logo-8`,
              `fi_logo-7`,
              `fi_logo-6`,
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
              `fi_logo-10`
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene9', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__title_9',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__title_9',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__title_9', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__title_9--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__title_9', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'year',
        type: customFieldTypes.TEXT,
        name: 'Edit Year',
        paths: [['scene9', 'year']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__year_9',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__year_9',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__year_9', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__year_9--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__year_9', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene9', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_slide__text_9',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_slide__text_9',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_slide__text_9', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_slide__text_9`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_slide__text_9', presetType: stylePresetType.HIDDEN }
        ]
      }
    ]
  },
  {
    id: 'lastScene',
    location: { scene: scenes[10] },
    siderbarPreview: {
      type: sidebarSceneType.IMAGE,
      path: ['scene10', 'bg'],
    },
    fields: [
      {
        id: 'image',
        type: customFieldTypes.IMAGE,
        name: 'Edit Background Image',
        paths: [['scene10', 'bg']],
        overlayStyle: overlayStyle.GreenTransparent,
        overlayKey: 'fi_signup__bg',
      },
      {
        id: 'logo',
        type: customFieldTypes.IMAGE,
        name: 'Edit Logo',
        paths: [['scene10', 'logo']],
        overlayStyle: overlayStyle.BlueField,
        overlayKey: 'fi_logo-10',
        customStyle: '.fi_logo-10 {\n}',
        stylePresets: [
          { title: 'Image position:', className: `fi_logo-10`, presetType: stylePresetType.POSITION },
          { title: 'Image size:', className: `fi_logo-10`, presetType: stylePresetType.ZOOM },
          {
            title: 'Add background around image:',
            className: `fi_logo-10`,
            presetType: stylePresetType.AROUND
          },
          {
            title: 'Apply size/positioning to all logos',
            // !!! first class' value is applied to the rest
            classNames: [
              `fi_logo-10`,
              `fi_logo-9`,
              `fi_logo-8`,
              `fi_logo-7`,
              `fi_logo-6`,
              `fi_logo-5`,
              `fi_logo-4`,
              `fi_logo-3`,
              `fi_logo-2`,
            ],
            getSlideClassName: num => `fi_logo-${num}`,
            presetType: stylePresetType.POSITION_ZOOM_ALL,
          },
        ]
      },
      {
        id: 'title',
        type: customFieldTypes.TEXT,
        name: 'Edit Title',
        paths: [['scene10', 'title']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_signup__heading',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_signup__heading',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_signup__heading', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_signup__heading--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_signup__heading', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'text',
        type: customFieldTypes.TEXT,
        name: 'Edit Text',
        paths: [['scene10', 'text']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_signup__text',
        stylePresets: [
          {
            title: 'Text color:',
            className: 'fi_signup__text',
            presetType: stylePresetType.COLOR,
            options: ['black', 'white']
          },
          { title: 'Text effects:', className: 'fi_signup__text', presetType: stylePresetType.TEXT_EFFECT },
          { title: 'Text size:', className: `fi_signup__text--text`, presetType: stylePresetType.TEXT_SIZE },
          { className: 'fi_signup__text', presetType: stylePresetType.HIDDEN }
        ]
      },
      {
        id: 'button',
        type: customFieldTypes.ACTION_BUTTON_W_EMAIL,
        name: 'Sign Up Button',
        paths: [['scene10', 'buttonText']],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: 'fi_signup__button',
        related: {
          email: [['scene10', 'email']],
          emailFieldNum: 5 // number of field for email prop to open
        }
      },
      {
        id: 'email',
        type: customFieldTypes.EMAIL_SETTINGS,
        name: 'Email settings',
        paths: [['scene10', 'email']],
        nonDOM: true
      }
    ]
  }
]

export default customFields



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/template/customFields.js